export function awaitForSeconds(seconds) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, 1000 * seconds);
  });
}

export const isFirefox = !!navigator.userAgent.match(/firefox/i);
